import React from 'react';
import { NumericFormat } from 'react-number-format';
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function DealMarketMedianIncomeField({
  value,
  error,
  setValue,
  setError,
}) {
  const handleChange = (values) => {
    setValue(values.floatValue);
  };
  return (
    <Box>
      <FormControl fullWidth>
        <NumericFormat
          value={value}
          prefix='$'
          onValueChange={handleChange}
          customInput={TextField}
          aria-describedby='market-median-income-helper-text'
          label='Median Income'
          id='market_median_income'
          error={Boolean(error)}
          variant='standard'
          thousandSeparator=','
        />

        {error ? (
          <FormHelperText id='market-median-income-helper-text'>
            {error}
          </FormHelperText>
        ) : (
          <FormHelperText id='market-median-income-helper-text'>
            Enter the market's median household income.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
